module.exports = __webpack_public_path__ + "img/FW_Moon&Star Staff.92a678e2.png";